module.exports = {
    apiKey: "AIzaSyA3qPJDCXKyoh4zi-4LaOuFZMVtKqcN8Pk",
    authDomain: "the-oz-project.firebaseapp.com",
    databaseURL: "https://the-oz-project.firebaseio.com",
    projectId: "the-oz-project",
    storageBucket: "the-oz-project.appspot.com",
    messagingSenderId: "705927968079",
    appId: "1:705927968079:web:e158556aa99bb23f5ec13a",
    measurementId: "G-WE6E8KRYQW"
};